/* ===========================================================================
   Share
   =========================================================================== */

const $share = document.getElementById('js-item-share');
let $temp = $("<input style='opacity: 0;'>"),
  $url = $(location).attr('href');

if ($share) {

  const share = ($this) => {
    const url = $this.getAttribute('href');

    if (url) {
      window.open(url, "", "height=600, width=600, left=100, top=100, menubar=0");
    }
  };

  $share.addEventListener('click', function(e) {
    e.preventDefault();

    const $this = e.target;

    if ($this && $this.matches('.js-share-item')) {
      share($this);
    }

  });
}

const shareBtn = document.querySelector('.share-button');
const title = document.getElementsByTagName("title")[0].innerHTML;
const url = document.querySelector('link[rel=canonical]') &&
  document.querySelector('link[rel=canonical]').href ||
  window.location.href;

if (shareBtn) {
  shareBtn.addEventListener('click', () => {
    if (navigator.share) {
      navigator.share({
        title,
        url
      }).then(() => {
        console.log("Sharing success");
      })
        .catch(err => {
          console.log("Sharing error");
        });
    } else {
      alert("Votre navigateur ne supporte pas la fonction de partage, mais l'URL de la page a été copiée.");
      $("body").append($temp);
      $temp.val($url).select();
      document.execCommand("copy");
      $temp.remove();
    }
  });
}

